import { createContext } from "react";

export const SucursalesContext = createContext()
export const SucursalesFormContext = createContext()
export const SucursalesReportContext = createContext()